import classnames from 'classnames'

import styles from './index.module.scss'

export enum TagVariants {
  Brand = 'brand',
  Highlight = 'highlight',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Neutral = 'neutral',
  NeutralLight = 'neutral-light',
}

export type TagProps = {
  label: string
  className?: string
  labelClassName?: string
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  size?: 'medium' | 'small'
  variant?: TagVariants
}

export const Tag = ({
  label,
  className,
  labelClassName = '',
  icon,
  size = 'medium',
  variant = TagVariants.Brand,
}: TagProps) => {
  const Icon = icon as React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  return (
    <div className={classnames(styles['tag'], styles[size], styles[variant], className)}>
      {icon && <Icon className={styles['icon']} />}
      <span className={labelClassName}>{label}</span>
    </div>
  )
}

export default Tag
